var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDietBlue01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#264D61;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:15;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#264D61;stroke-width:40;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 272.1,
    r: 142.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,287.2c-8.4,0-15.1-6.8-15.1-15.1l6.6-83.9c0-8.4,0.3-11.5,8.7-11.5s9.3,3.2,9.3,11.5l5.8,83.9 C271.1,280.4,264.4,287.2,256,287.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 369.8,
    y1: 274.9,
    x2: 339.8,
    y2: 274.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.7,
    y1: 276,
    x2: 144.7,
    y2: 276
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 256.4,
    y1: 356,
    x2: 256.4,
    y2: 386
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M112.1,66.4C140.5,82,192.7,105,260.2,104c63-0.9,111.8-22.3,139.7-37.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381.6,442.8H130.4c-7.3,0-12.2-7.4-9.4-14.1l17.4-41.4c2.8-6.6,11.2-8.4,16.4-3.5 c16.8,16,52.4,42.8,103.6,42.1c48.9-0.7,82.9-26.3,99.2-41.9c5.2-5,13.7-3.1,16.5,3.5c5.7,13.8,11.4,27.5,17.1,41.3 C393.8,435.4,388.9,442.8,381.6,442.8L381.6,442.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDietBlue01);
export default __webpack_public_path__ + "static/media/Diet_blue-01.495d583b1734e2c53e5f30febaef0f4a.svg";
export { ForwardRef as ReactComponent };